import React from 'react';

import DepartmentCard from './DepartmentCard';
import InlineNameForm from './InlineNameForm';

/**
 * One side of the budget structure — expenditure or revenue — as department
 * cards, each tagged with its side, or a line saying there are none yet. The
 * "add department" form opens here, from the page-level buttons.
 */
export default function StructureSection({
    id,
    typeLabel,
    emptyText,
    addCentreLabel,
    departments,
    canEdit,
    canRename,
    canDelete,
    canOpenDetails,
    adding,
    onAddDepartment,
    onCancelAdd,
    onAddCentre,
    onRename,
    onDelete,
}) {
    return (
        <section className="tw-flex tw-flex-col tw-gap-y-2" aria-label={typeLabel}>
            {departments.length === 0 && !adding && <p className="tw-text-sm tw-text-charcoal-50 tw-mb-0">{emptyText}</p>}

            {departments.map((department) => (
                <DepartmentCard
                    key={department.id}
                    department={department}
                    typeLabel={typeLabel}
                    canEdit={canEdit}
                    canRename={canRename}
                    canDelete={canDelete}
                    canOpenDetails={canOpenDetails}
                    addCentreLabel={addCentreLabel}
                    onAddCentre={onAddCentre}
                    onRename={onRename}
                    onDelete={onDelete}
                />
            ))}

            {canEdit && adding && (
                <div className="tw-px-4 tw-py-3 tw-rounded-lg tw-border tw-border-charcoal-15 tw-bg-background">
                    <InlineNameForm
                        id={`${id}-new-department`}
                        label={$t('Department name')}
                        placeholder={$t('Department name')}
                        onSubmit={onAddDepartment}
                        onCancel={onCancelAdd}
                    />
                </div>
            )}
        </section>
    );
}
